import {
	SET_GPS_STOPPED,
	SET_POSITION,
	GEOLOCALISATION_IN_PROGRESS,
} from "./gpsConstants";
import { throwErrorMessage } from "../../lib/error_helper";
import { MODULE_SAISIE_TEMPS } from "../authorizedApps/authorizedAppsConstants";

export function setGpsStoppedAction(gpsStopped) {
	return {
		type: SET_GPS_STOPPED,
		gpsStopped: gpsStopped,
	};
}

function setPositionAction(position) {
	return {
		type: SET_POSITION,
		position,
	};
}

function geolocalisationInProgress(value) {
	return {
		type: GEOLOCALISATION_IN_PROGRESS,
		value,
	};
}

export function getDefaultPosition() {
	return {
		lon: 0,
		lat: 0,
	};
}

export function setGpsStopped(value) {
	return (dispatch) => {
		dispatch(setGpsStoppedAction(value));
	};
}

export function getGpsPosition(authorizedApps) {
	return (dispatch) => {
		let options = {
			enableHighAccuracy: true,
			timeout: 10000,
			maximumAge: 15000,
		};

		dispatch(geolocalisationInProgress(true));

		navigator.geolocation.watchPosition(
			gpsPositionSuccess.bind(null, dispatch),
			gpsPositionError.bind(null, dispatch, authorizedApps),
			options
		);
	};
}

function gpsPositionSuccess(dispatch, position) {
	dispatch(setPositionAction(position));
	dispatch(geolocalisationInProgress(false));
}

export function gpsPositionError(dispatch, authorizedApps, error) {
	dispatch(geolocalisationInProgress(false));
	let module = authorizedApps.find(
		(authorizedApp) => authorizedApp.code === MODULE_SAISIE_TEMPS
	);
	let helpUrl = "";

	let inLineHelpLabel = "l'aide en ligne";

	if (module) helpUrl = module.HelpUrl;

	switch (error.code) {
		case error.PERMISSION_DENIED:
			//User denied the request for Geolocation.
			dispatch(
				throwErrorMessage({
					title: "Attention",
					message: (
						<div>
							{
								"La géolocalisation n'a pas encore été autorisée. Veuillez consulter "
							}
							{helpUrl ? (
								<a target="_blank" rel="noreferrer noopener" href={helpUrl}>
									{inLineHelpLabel}
								</a>
							) : (
								inLineHelpLabel
							)}
						</div>
					),
				})
			);
			dispatch(setGpsStopped(true));
			break;
		case error.POSITION_UNAVAILABLE:
			//Location information is unavailable.
			dispatch(
				throwErrorMessage({
					title: "Attention",
					message:
						"La géolocalisation est désactivée sur cet appareil. Veuillez l'activer dans les paramètres de celui-ci. Si vous n'y parvenez pas, contactez le support applicatif",
				})
			);
			dispatch(setGpsStopped(true));
			break;
		case error.TIMEOUT:
			//The request to get user location timed out.
			//Tout est activé et autorisé mais le périphérique ne repère aucune localisation GPS
			//On a rien à faire de spécial
			console.error(
				"Timeout rencontré lors de la tentative de géolocalisation"
			);
			break;
		case error.UNKNOWN_ERROR:
			//An unknown error occurred.
			dispatch(
				throwErrorMessage({
					title: "Attention",
					message:
						"Une erreur s'est produite lors de la tentative de géolocalisation. Veuillez contacter le support applicatif",
				})
			);
			break;
		default:
			console.error("Erreur non gérée lors de la tentative de géolocalisation");
			break;
	}
}
